import { EMAIL_VALIDATION_REGEX } from '@chownow/cn-web-utils/validation';

const translate = { c: 'cuisines', r: 'restaurants' };
/**
 * Formats the autocomplete responses by expanding the single
 * letter variables into meaningful names by using the translator
 * defined above.
 *
 * @param {Array|null} results
 * @param {string} results.t - the type of result ('c' -> cuisine, 'r' -> restaurant)
 * @param {string} results.n  - the name of the result
 * @param {string|null} results.id - the id of a restaurant (if only 1 in area)
 *
 * @returns {(Object|null)} - Object partitioned by type, null if no results
 */
export default function formatAutocomplete(results) {
  const formattedResults = {
    cuisines: [],
    restaurants: [],
  };
  if (!results || results.o?.length === 0) return formattedResults;
  results.o.forEach((result) => {
    const type = translate[result.t];
    const obj = { name: result.n };

    if (result.id) obj.id = result.id;

    formattedResults[type].push(obj);
  });

  return formattedResults;
}

export function validateEmailFormat(email) {
  const error = '';

  if (!email) {
    return 'Email is required';
  } else if (!EMAIL_VALIDATION_REGEX.test(email)) {
    return 'Please enter a valid email address';
  }

  return error;
}
